import { ComponentProps } from 'lib/component-props';
import { Field, ImageField, TextField } from '@sitecore-jss/sitecore-jss-react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useRouter } from 'next/router';
import { useState, useEffect, useRef } from 'react';
import { StActionButtonContainer, StInfoContainer, StInfoWrapper } from './AddToMyInterest.styles';
import { fetchProfileVerifyTokenKey, setchProfileVerifyTokenKey } from '../../lib/utils/common';
import ProfileModal from '../MyProfile/Modal/ProfileModal';
import VerificationAlert from './VerificationAlert/VerificationAlert';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { RootState } from '../../store/store';
import { useSelector, useDispatch } from 'react-redux';
import { SendEmailCategories } from '../../lib/type/common';
import isEmpty from 'lodash/isEmpty';
import {
  setProfileData,
  updateIsEmailLinkExpired,
  updateSelectedCommunities,
  updateSelectedCOI,
} from '../../features/crProfileSlice';
import { updateCommunitiesToCDP } from '../../services/RegisterUserService';
import { hideLoader, showLoader } from '../../features/loaderSlice';
//import axios from 'axios';
import { CDP_EVENTS } from '../../../src/constants';
import * as cdpService from '../../services/CdpService';
import CRModal from '../CR/CRModal';
import uniqBy from 'lodash/uniqBy';
import filter from 'lodash/filter';
import UiBox from '../shared/Box';
import ButtonPrimary from '../shared/Button/PrimaryButton';
import ButtonSecondary from '../shared/Button/SecondaryButton';
import { Star, CancelOutlined } from '@mui/icons-material';
import UiHeading from '../shared/Heading';
import Head from 'next/head';

interface AddToMyInterestField {
  addToMyInterestText?: TextField;
  removeMyInterestText?: TextField;
  title?: TextField;
  backgroundImage?: ImageField;
  fontColor?: Field<string>;
  description?: Field<string>;
}
interface AddToMyInterestProps extends ComponentProps {
  fields?: AddToMyInterestField;
}

// interface ICustomPathsArray {
//   name: string;
//   value: string;
// }

const ActionTypeEnum = {
  IS_UPDATE_EXISTING: 'isUpdateExisting',
  IS_DELETE_EXISTING: 'isDeleteExisting',
  IS_APPEND_EXISTING: 'isAppendExisting',
};

const AddToMyInterest: React.FC<AddToMyInterestProps> = (props) => {
  const router = useRouter();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { sitecoreContext } = useSitecoreContext();
  const { route } = sitecoreContext || {};
  const relativeCommunityId = (route?.fields?.relatedCommunity as any)?.fields?.value?.value || '';
  const [isInterested, setIsInterested] = useState<boolean | null>(null);
  const [profileModal, setProfileModal] = useState({ open: false, profileFields: {} });
  const [showCommunityMemberBanner, setShowCommunityMemberBanner] = useState(false);
  const crProfile = useSelector((state: RootState) => state.crProfile);
  const isAuthenticated: boolean = useSelector(
    (state: RootState) => state.authentication.isAuthenticated
  );
  const isEmailLinkExpired = crProfile?.isEmailLinkExpired;
  const linkExpiredModelPopup: any = route?.fields?.linkExpiredModelPopup;
  const expiredModalDescription = linkExpiredModelPopup?.fields?.description;
  const expiredModallink = linkExpiredModelPopup?.fields?.link;
  const expiredModallinkText = linkExpiredModelPopup?.fields?.linkText;
  const expiredModalTitle = linkExpiredModelPopup?.fields?.title;
  const usePageUrl = linkExpiredModelPopup?.fields?.usePageUrl;
  const fontColor = props?.fields?.fontColor?.value;

  const handleExpireModalContinue = async () => {
    await dispatch(updateIsEmailLinkExpired(false));
    if (!usePageUrl?.value) router.push(expiredModallink?.value?.href);
  };

  const onIntrestAddRemovedClick = async () => {
    const myProfileVerificationToken = fetchProfileVerifyTokenKey();
    if (!myProfileVerificationToken) {
      setProfileModal({
        open: true,
        profileFields: {
          ...route?.fields,
          myProfile: route?.fields?.communityModal,
          resendCount: (route?.fields?.resendCount as any)?.value,
        },
      });
    } else {
      if (!isInterested) {
        await addRemoveIntrestClickCDP(ActionTypeEnum.IS_UPDATE_EXISTING, true);
      } else {
        await addRemoveIntrestClickCDP(ActionTypeEnum.IS_DELETE_EXISTING);
      }
    }
  };

  const checkAndSetConditionAndCommunityToStore = async (array: any) => {
    const profileData = array?.data || array;
    const coiArray = profileData?.conditions || profileData?.conditions;
    const communityArray = profileData?.communities || profileData?.communities;
    const coiDataList = uniqBy(filter(coiArray, 'sitecoreId'), 'conditionValue');
    const communityDataList = uniqBy(filter(communityArray, 'sitecoreId'), 'communityValue');
    const convertedCommunities =
      communityDataList &&
      communityDataList.map((community: any) => ({
        id: community.communityId,
        sitecoreId: community.sitecoreId,
        text: community.communityValue,
      }));
    dispatch(setProfileData(profileData));
    dispatch(updateSelectedCOI(coiDataList));
    dispatch(updateSelectedCommunities(convertedCommunities));
  };

  const addRemoveIntrestClickCDP = async (actionType: string, isInterest = false) => {
    try {
      dispatch(showLoader());
      let isAppendExisting = false;
      const relatedCommunityConditions = (props?.fields as any)?.relatedCommunityConditions || [];
      const relatedCommunity =
        (!isEmpty(relatedCommunityConditions) &&
          relatedCommunityConditions?.flatMap((COI: any) => [...COI?.communities])) ||
        [];

      let COIData = relatedCommunityConditions?.map((item: any) => ({
        sitecoreId: item.sitecoreId,
        text: item.description,
        id: item.value,
      }));
      const initialCOIData = COIData;

      let communitiesData = relatedCommunity?.map((item: any) => ({
        sitecoreId: item?.sitecoreId,
        text: item?.description,
        id: item?.value,
      }));
      communitiesData = uniqBy(communitiesData, 'id');
      if (!crProfile?.profileData?.communities && !crProfile?.profileData?.conditions) {
        isAppendExisting = true;
      }
      const presentCommunity = crProfile?.profileData?.communities?.find(
        (a: any) => a.communityId === relativeCommunityId
      );
      const presentCondition = crProfile?.profileData?.conditions?.find(
        (a: any) => a.conditionId === relativeCommunityId
      );
      const communityArray = crProfile?.profileData?.communities?.map((item: any) => ({
        sitecoreId: item?.sitecoreId,
        text: item?.communityValue,
        id: item?.communityId,
      }));
      const conditionArray = crProfile?.profileData?.conditions?.map((item: any) => ({
        sitecoreId: item?.sitecoreId,
        text: item?.conditionValue,
        id: item?.conditionId,
      }));
      if (isInterest) {
        communitiesData = !presentCommunity
          ? communityArray && communityArray.length > 0
            ? [...communitiesData, ...communityArray]
            : [...communitiesData]
          : [...communityArray];
        COIData = !presentCondition
          ? conditionArray && conditionArray.length > 0
            ? [...COIData, ...conditionArray]
            : [...COIData]
          : [...conditionArray];
      } else {
        communitiesData = [...communitiesData, ...communityArray]?.filter(
          (a: any) => a.id !== relativeCommunityId
        );
        COIData = [...COIData, ...conditionArray];
        COIData = COIData?.filter(
          (item: any) => !initialCOIData.some((cond: any) => cond.id === item.id)
        );
      }

      COIData = uniqBy(filter(COIData, 'sitecoreId'), 'text');
      communitiesData = uniqBy(filter(communitiesData, 'sitecoreId'), 'text');

      if (actionType === ActionTypeEnum.IS_UPDATE_EXISTING) {
        cdpService.event(CDP_EVENTS.ADD_COMMUNITY, { communityName: sitecoreContext.route?.name });
        setTimeout(() => {
          cdpService.event(CDP_EVENTS.BASE_PROFILE_UPDATED, { reference: 'community_update' });
        }, 5000);
      } else {
        cdpService.event(CDP_EVENTS.REMOVE_COMMUNITY, {
          communityName: sitecoreContext.route?.name,
        });
        setTimeout(() => {
          cdpService.event(CDP_EVENTS.BASE_PROFILE_UPDATED, { reference: 'community_update' });
        }, 5000);
      }

      const response = await updateCommunitiesToCDP(COIData, communitiesData, isAppendExisting);

      if (response?.status === 200) {
        dispatch(setProfileData(response?.data));
        checkAndSetConditionAndCommunityToStore(response);
        if (actionType === ActionTypeEnum.IS_UPDATE_EXISTING) {
          setShowCommunityMemberBanner(true);
          setIsInterested(true);
        } else {
          setShowCommunityMemberBanner(false);
          setIsInterested(false);
        }
      }
    } catch (error) {
    } finally {
      dispatch(hideLoader());
    }
  };

  const ActionButton = () => {
    // Don't render buttons until we know the interest status from API
    if (isInterested === null) return null;

    return (
      <UiBox
        id="action-button-set"
        styles={{ display: 'flex', columnGap: '15px', minWidth: '260px' }}
      >
        {isInterested && (
          <ButtonSecondary
            fullWidth
            onClick={onIntrestAddRemovedClick}
            iconRight={<CancelOutlined />}
          >
            {String(props.fields?.removeMyInterestText?.value)}
          </ButtonSecondary>
        )}
        {!isInterested && (
          <ButtonPrimary fullWidth onClick={onIntrestAddRemovedClick} iconRight={<Star />}>
            {String(props.fields?.addToMyInterestText?.value)}
          </ButtonPrimary>
        )}
      </UiBox>
    );
  };

  const checkandSetCommunityToken = async (
    communityToken: string,
    isCommunityToken: boolean,
    expiryTime?: number
  ) => {
    try {
      if (!sitecoreContext?.route?.fields?.relatedCommunity) {
        setShowCommunityMemberBanner(false);
        return;
      }
      dispatch(showLoader());
      const response = await setchProfileVerifyTokenKey(communityToken, expiryTime);
      await checkAndSetConditionAndCommunityToStore(response);
      dispatch(hideLoader());
      const selectedCommunities = response?.communities || [];
      const relatedCommunityValue = (sitecoreContext?.route?.fields?.relatedCommunity as any)
        ?.fields?.value?.value;

      if (!isEmpty(selectedCommunities) && !isEmpty(relatedCommunityValue)) {
        const isExist = selectedCommunities?.find(
          (community: { communityId: string; sitecoreId: string; communityValue: string }) =>
            community.communityId === relatedCommunityValue
        );

        if (!isEmpty(isExist)) {
          setIsInterested(true);
          setShowCommunityMemberBanner(true);
        } else {
          if (isCommunityToken) {
            await addRemoveIntrestClickCDP(ActionTypeEnum.IS_UPDATE_EXISTING, true);
          } else {
            setIsInterested(false);
            setShowCommunityMemberBanner(false);
          }
        }
      } else {
        if (isCommunityToken) {
          await addRemoveIntrestClickCDP(ActionTypeEnum.IS_UPDATE_EXISTING, true);
        } else {
          setIsInterested(false);
          setShowCommunityMemberBanner(false);
        }
      }
    } catch (error) {
      setIsInterested(false);
    } finally {
      dispatch(hideLoader());
    }
  };

  const isLoadedFirst = useRef<any>(true);

  useEffect(() => {
    (async function () {
      if (router?.isReady && router?.query?.communityToken) {
        const linkExpiredModelPopup: any = sitecoreContext?.route?.fields?.linkExpiredModelPopup;
        const expiryTime = linkExpiredModelPopup?.fields?.expiryTime;

        if (isLoadedFirst.current) {
          setTimeout(() => {
            cdpService.event(CDP_EVENTS.UPDATE_COMMUNITY_EMAIL, {
              communityName: sitecoreContext.route?.name,
            });
          }, 5000);
          isLoadedFirst.current = false;
        }

        await checkandSetCommunityToken(
          router?.query?.communityToken as string,
          true,
          expiryTime?.value
        );
      }
    })();
  }, [router?.isReady, router?.query]);

  useEffect(() => {
    (async function () {
      const myProfileVerificationToken = fetchProfileVerifyTokenKey();
      if (
        myProfileVerificationToken &&
        myProfileVerificationToken !== router?.query?.communityToken
      ) {
        isLoadedFirst.current = false;
        dispatch(showLoader());
        await checkandSetCommunityToken(myProfileVerificationToken as string, false);
        dispatch(hideLoader());
      } else {
        // No token found, set initial state to false
        setIsInterested(false);
      }
    })();
  }, [sitecoreContext?.route]);

  const renderJSONLDSchema = () => {
    // JSON-LD structured data
    const schemaData = {
      '@context': 'https://schema.org',
      '@type': 'MedicalCondition',
      name: props?.fields?.title?.value || '',
      alternateName: props?.fields?.title?.value || '',
      description: props?.fields?.description?.value || '',
    };
    return (
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
      </Head>
    );
  };

  if (!props?.fields) return <></>;
  return (
    <>
      {renderJSONLDSchema()}
      {!!linkExpiredModelPopup && (
        <CRModal
          open={isEmailLinkExpired}
          title={expiredModalTitle?.value}
          confirmButton={{ name: expiredModallinkText?.value }}
          handleClose={() => dispatch(updateIsEmailLinkExpired(false))}
          handleContinue={handleExpireModalContinue}
        >
          <Typography sx={{ color: theme.palette.neutral8.main }}>
            {expiredModalDescription?.value}
          </Typography>
        </CRModal>
      )}
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexWrap: 'nowrap',
          backgroundSize: 'cover',
          height: '470px',
        }}
        id="add-to-my-interest"
        className="ui-add-to-my-interest"
      >
        {props.fields?.backgroundImage && (
          <NextImage
            field={props.fields?.backgroundImage}
            priority={true}
            style={{ zIndex: 0, objectFit: 'cover', objectPosition: 'center' }}
            fill={true}
          ></NextImage>
        )}
        <Box
          display={'flex'}
          flexDirection={'column'}
          width={'100%'}
          justifyContent={'space-between'}
          sx={{ zIndex: 1 }}
        >
          <StActionButtonContainer>
            {!showCommunityMemberBanner && <ActionButton />}
          </StActionButtonContainer>
          <StInfoContainer>
            <StInfoWrapper className="ui-add-to-my-interest__info-wrapper">
              <UiHeading size="h2" color="black" styles={{ color: fontColor }}>
                {props.fields?.title}
              </UiHeading>
              {!showCommunityMemberBanner && <ActionButton />}
            </StInfoWrapper>
          </StInfoContainer>
        </Box>
      </Box>
      {profileModal.open && (
        <ProfileModal
          modal={{ open: profileModal.open, setProfileModal } as any}
          fieldProps={{ ...profileModal.profileFields }}
          emailType={SendEmailCategories.COMMUNITY_LANDING}
          communityPageLink={router?.asPath?.split('?')[0]}
        />
      )}
      {showCommunityMemberBanner && isAuthenticated && (
        <VerificationAlert
          severity={'success'}
          link={(route?.fields?.bannerLink as any)?.value?.href || '#'}
          linkText={(route?.fields?.bannerLink as any)?.value?.text || ''}
          text={(route?.fields?.bannerText as any)?.value || 'string'}
          icon={<CheckCircleIcon fontSize="inherit" />}
          closeAlert={() => setShowCommunityMemberBanner(false)}
        />
      )}
    </>
  );
};
export default AddToMyInterest;
